import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useT } from "@/context/LanguageContext";
import { Hero } from "@/components/home/Hero";
import { BlogNews } from "@/components/home/BlogNews";
import { CurrencyTicker } from "@/components/home/CurrencyTicker";
import { LogoMarquee } from "@/components/home/LogoMarquee";
import { Marketplaces } from "@/components/home/Marketplaces";
import { Services } from "@/components/home/Services";
import { Industries } from "@/components/home/Industries";
import { Stats } from "@/components/home/Stats";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Categories } from "@/components/home/Categories";
import { StartBrand } from "@/components/home/StartBrand";
import { VideoShowcase } from "@/components/home/VideoShowcase";
import { Testimonials } from "@/components/home/Testimonials";
import { CaseTeaser } from "@/components/home/CaseTeaser";
import { LeadMagnet } from "@/components/home/LeadMagnet";
import { CTASection } from "@/components/home/CTASection";

export default function Home() {
  const { lang } = useT();
  const [data, setData] = useState({ services: [], industries: [], categories: [], testimonials: [], videos: [], resources: [], stats: {}, caseStudies: [] });

  useEffect(() => {
    const load = async () => {
      try {
        const [services, industries, categories, testimonials, videos, resources, stats, caseStudies] = await Promise.all([
          api.get("/services"), api.get("/industries"), api.get("/product-categories"),
          api.get("/testimonials"), api.get("/videos"), api.get("/resources"), api.get("/stats"),
          api.get("/case-studies"),
        ]);
        setData({
          services: services.data, industries: industries.data, categories: categories.data,
          testimonials: testimonials.data, videos: videos.data, resources: resources.data, stats: stats.data,
          caseStudies: caseStudies.data,
        });
      } catch (e) { console.error("Failed to load homepage content:", e); }
    };
    load();
  }, [lang]);

  return (
    <div data-testid="home-page">
      <Hero />
      <BlogNews />
      <CurrencyTicker />
      <LogoMarquee />
      <Services services={data.services} />
      <Industries industries={data.industries} />
      <Stats stats={data.stats} />
      <CaseTeaser studies={data.caseStudies} />
      <HowItWorks />
      <Categories categories={data.categories} />
      <Marketplaces />
      <StartBrand />
      <VideoShowcase videos={data.videos} />
      <Testimonials testimonials={data.testimonials} />
      <LeadMagnet resources={data.resources} />
      <CTASection />
    </div>
  );
}
